__turbopack_context__.v({
  "categoryLabel": "ComparePlans-module__xIqhqq__categoryLabel",
  "categoryLabelWrapper": "ComparePlans-module__xIqhqq__categoryLabelWrapper",
  "categoryRow": "ComparePlans-module__xIqhqq__categoryRow",
  "categoryThumbnail": "ComparePlans-module__xIqhqq__categoryThumbnail",
  "categoryWrapper": "ComparePlans-module__xIqhqq__categoryWrapper",
  "closeButton": "ComparePlans-module__xIqhqq__closeButton",
  "container": "ComparePlans-module__xIqhqq__container",
  "gridRow": "ComparePlans-module__xIqhqq__gridRow",
  "headerCell": "ComparePlans-module__xIqhqq__headerCell",
  "headerRow": "ComparePlans-module__xIqhqq__headerRow",
  "itemName": "ComparePlans-module__xIqhqq__itemName",
  "itemRow": "ComparePlans-module__xIqhqq__itemRow",
  "itemTextValue": "ComparePlans-module__xIqhqq__itemTextValue",
  "itemValue": "ComparePlans-module__xIqhqq__itemValue",
  "itemsContainer": "ComparePlans-module__xIqhqq__itemsContainer",
  "mobileBreak": "ComparePlans-module__xIqhqq__mobileBreak",
  "separator": "ComparePlans-module__xIqhqq__separator",
  "tableBody": "ComparePlans-module__xIqhqq__tableBody",
  "tableBodyContent": "ComparePlans-module__xIqhqq__tableBodyContent",
});
